export default __webpack_public_path__ + "static/media/Create-documentation.9b3de092.md";